import { gql } from '@apollo/client';

const regionFragment = gql`
  fragment RegionFields on AppraiserEventRegion {
    EventTakesPlacesInAfrica
    EventTakesPlacesInAsia
    EventTakesPlacesInAustralia
    EventTakesPlacesInEurope
    EventTakesPlacesInNorthAmerica
    EventTakesPlacesInSouthAmerica
  }
`;

export default regionFragment;
